const HamburgerMenuClose = () => {
      return (
            <svg
                  viewBox="0 0 33 32"
                  height={"32px"}
                  width={"32px"}
                  stroke="currentColor"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  strokeWidth="1.5"
                  strokeLinecap="round"
            >
                  <path d="M4.75 9.33301H28.75" />
                  <path d="M17 16L29 16" />
                  <path d="M4.75 22.667H28.75" />
            </svg>
      );
};

export default HamburgerMenuClose;
